import React, { useEffect, useMemo, useState } from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import "chart.js/auto"; // auto registers all components

import {
  getManpowerDashboardData,
  jobFTEs,
  getAllRevenueGeneratorsSimulationDashboard,
  getAllRevenueGenerators,
  getManpowerOrgChartData,
} from "services/api";
import PropTypes from "prop-types";
import { useAuth } from "context/authContext";
import LoadingScreen from "components/Loading";
import { useTranslation } from "react-i18next";

import ManpowerAnalysisChart from "../Components";
import { getScoresForOrg } from "services/api";
import { getScoresForScenario, getAnalysisPageData } from "services/api";

const ManpowerAnalysisPage = ({ scenarioJobs, scenario }) => {
  const { t } = useTranslation();
  const { employee } = useAuth();
  const [data, setData] = useState([]); //Store Scenario Jobs
  const [extraData, setExtraData] = useState({ totalEmployees: 0 });
  const [spendings, setSpendings] = useState(0);
  const [revenueGeneratorsScenario, setRevenueGeneratorsScenario] = useState([]);
  const [revenueGeneratorsTeam, setRevenueGeneratorsTeam] = useState([]);
  const [scenarioEmployees, setScenarioEmployees] = useState([]);
  const [orgEmployees, setOrgEmployees] = useState([]);
  const [selectedJob, setSelectedJob] = useState();
  // const [revenueGeneratorsScenarioWithEmps, setRevenueGeneratorsScenarioWithEmps] = useState([]);
  const [avgProductivityPerYear, setAvgProductivityPerYear] = useState(0);
  const [jobSalary, setJobSalary] = useState({});

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // ✅ Case 1: If scenarioJobs exist, use them directly
        if (scenarioJobs && scenario) {
          // Sort by jobId
          const sorted = [...scenarioJobs].sort((a, b) => a.jobId - b.jobId); //scenario jobs sorted

          // Calculate total employees (sum of FTEs)
          // const total = sorted.reduce((sum, item) => sum + (item.numberOfEmployees || 0), 0);
          const total = sorted.length > 0 ? sorted[0].totalCompanyEmployees : 0;
          setExtraData({ totalEmployees: total });

          // 🆕 Get all scenario employees DTO
          const scenarioEmployeesRes = await getScoresForScenario(scenario?.id);
          if (scenarioEmployeesRes !== "error") {
            setScenarioEmployees(scenarioEmployeesRes);
          }

          // ///New Additions//////////////////////////
          const totalCost = sorted.reduce(
            (sum, job) => sum + (job.salary ?? 0) * (job.numberOfEmployees ?? 0),
            0
          );
          setSpendings(totalCost); //Bugdet Spent (Staff Cost In a year)

          //get all revenue generators in simulation d.b
          const revGenRes = await getAllRevenueGeneratorsSimulationDashboard();

          if (revGenRes !== "error") {
            //Get the revenue generators for the current scenario jobs
            const matchingRevGeneratorsForScenario = revGenRes.filter((rg) =>
              scenarioJobs.some((job) => job.id === rg.jobId)
            );
            setRevenueGeneratorsScenario(matchingRevGeneratorsForScenario);

            const matchingRevGeneratorsWithEmployees = matchingRevGeneratorsForScenario.map(
              (rg) => {
                const matchingJob = scenarioJobs.find((job) => job.id === rg.jobId);

                return {
                  ...rg,
                  totalEmployees: matchingJob?.numberOfEmployees || 0, // directly use the matching job
                };
              }
            );

            // setRevenueGeneratorsScenarioWithEmps(matchingRevGeneratorsWithEmployees);

            const revGeneratorsOpex = matchingRevGeneratorsWithEmployees.filter(
              (rg) =>
                rg.name.toLowerCase().includes("revenue") ||
                rg.name.includes("إيرادات") ||
                rg.name.includes("ايرادات")
            );

            //Get total avg producitivy per month (sum of the productivity of all rev gens)

            const totalAvgProductivityPerMonth = revGeneratorsOpex.reduce(
              (sum, rg) => sum + (rg.avgProductivityPerMonth || 0) * (rg.totalEmployees || 0),
              0
            );

            const avgProductivityPerYearAllRevGens = totalAvgProductivityPerMonth * 12;
            setAvgProductivityPerYear(avgProductivityPerYearAllRevGens); //Total Cost (In a year)

            //For each scenario job: store its cost per fte = salary, annual salary
            const calculatedJobSalary = scenarioJobs.reduce((acc, job) => {
              const monthlySalary = job.salary || 0;
              const jobTitle = job.jobName;
              const revGen = job.revenueGenerator;
              //Build a new object per job
              acc[job.id] = {
                monthlySalary,
                annualSalary: monthlySalary * 12, // multiply by 12 to get yearly total
                jobTitle,
                revGen,
              };
              return acc;
            }, {});
            setJobSalary(calculatedJobSalary);
          } else {
            console.error("Failed to fetch revenue generators");
          }

          ///New Additions//////////////////////////

          // Merge or adapt data as needed (e.g., fte = numberOfEmployees)
          const merged = sorted.map((job) => ({
            ...job,
            fte: job.numberOfEmployees || 0,
          }));

          setData(merged); //Scenario Jobs Stored
          return; // ✅ Exit early — no need for API calls
        }

        // ✅ Case 2: Otherwise, fetch from API

        // const [jobFtesRes, orgEmployeesRes, manpowerOrgChartData] = await Promise.all([
        //   jobFTEs(),
        //   getScoresForOrg(employee?.jobId),
        //   getManpowerOrgChartData(),
        // ]);

        //NEW///////
        const [analysisData, manpowerOrgChartData] = await Promise.all([
          getAnalysisPageData(employee?.jobId),
          getManpowerOrgChartData(),
        ]);
        const jobFtesRes = analysisData.jobFtesData;
        const orgEmployeesRes = analysisData.empScores;
        //NEW///////

        if (jobFtesRes !== "error" && manpowerOrgChartData !== "error") {
          const ids = data.map((j) => j.jobId);
          //New
          // const analysisData = await getAnalysisPageData(employee?.jobId, ids);
          //
          const revGeneratorsTeam = await getAllRevenueGenerators(ids);
          if (revGeneratorsTeam == "error") return;

          if (orgEmployeesRes !== "error") {
            setOrgEmployees(orgEmployeesRes);
          }

          // sort dashboard data
          // const sorted = [...dashboardRes].sort((a, b) => a.jobId - b.jobId);
          const sorted = [...manpowerOrgChartData].sort((a, b) => a.jobId - b.jobId);

          // calculate total employees
          const total = jobFtesRes.reduce((sum, item) => sum + (item[1] || 0), 0);
          setExtraData({ totalEmployees: total });

          // merge FTE values into dashboard data
          const merged = sorted.map((job) => {
            const ftePair = jobFtesRes.find((f) => f[0] === job.jobId);
            const fte = ftePair ? ftePair[1] : 0;
            return { ...job, fte };
          });

          setRevenueGeneratorsTeam(revGeneratorsTeam);
          setData(merged);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [employee?.jobId, scenarioJobs, scenario]);

  const {
    counts,
    revJobs,
    nonRevJobs,
    // workload,
    staffingData,
    revenueData,
    nonRevenueData,
    workloadJobs,
    costPerFteData,
    sortedWorkloadJobs,
    sortedWorkloadJobsNumeric,
    workloadRechartData,
    opexRevenueData, // ✅ new
    revenueSalaryData, // ✅ new
    nonRevenueSalaryData, // ✅ new
  } = useMemo(() => {
    let counts = { under: 0, over: 0, balanced: 0 };
    let revJobs = [];
    let nonRevJobs = [];
    // let workload = { under: 0, over: 0, balanced: 0 };

    const workloadJobs = [];

    // iterating through scenario jobs(for each record)
    data.forEach((job) => {
      // const fte = job.fte ?? 0; //scenario job Fte
      const req = job; //scenario job
      if (!req) return;

      const diff = req.diff;
      if (diff !== null && diff !== undefined) {
        if (diff < 0) counts.under++;
        else if (diff > 0) counts.over++;
        else counts.balanced++;
      }

      if (req.revenueGenerator === true) {
        revJobs.push({
          name: req.jobName,
          actual: req.numberOfEmployees ?? req.fte ?? 0,
          requiredFTE: req.requiredFTE ?? 0,
        });
      }

      if (req.revenueGenerator === false) {
        nonRevJobs.push({
          name: req.jobName,
          actual: req.numberOfEmployees ?? req.fte ?? 0,
          requiredFTE: req.requiredFTE ?? 0,
        });
      }

      // ---------- Workload Analysis ----------
      //Calculating the workload for each scneario job
      if (
        typeof req.utilization === "number" &&
        !Number.isNaN(req.utilization) &&
        req.utilization > 0
      ) {
        // const pct =
        //   ((req.actualHoursPerWeek - req.contractualHoursPerWeek) / req.contractualHoursPerWeek +
        //     1) *
        //   100;
        const utilization = req.utilization;
        const pct = utilization;
        workloadJobs.push({
          name: req.jobName,
          pct: pct.toFixed(1), // keep 1 decimal
        });
      }
    });

    // ---------- Workload Analysis ----------

    // ---------- Staffing Balance Chart Data ----------
    const staffingData = {
      labels: [
        t("user.manpowerPlanningAnalysis.chart.understaffed"),
        t("user.manpowerPlanningAnalysis.chart.balanced"),
        t("user.manpowerPlanningAnalysis.chart.overstaffed"),
      ],
      datasets: [
        {
          data: [counts.under, counts.balanced, counts.over],
          backgroundColor: ["#ef5350", "#108092", "#ffa726"],
        },
      ],
    };

    // ---------- Staffing Balance Chart Data ----------

    //---------- FTE Gap Analysis---------------------

    const revJobsSorted = [...revJobs]
      .filter(
        (j) =>
          Number.isFinite(j.requiredFTE) &&
          Number.isFinite(j.actual) &&
          !(j.requiredFTE === 0 && j.actual === 0)
      )
      .map((j) => ({
        ...j,
        difference: j.requiredFTE - j.actual,
      }))
      .sort((a, b) => b.difference - a.difference);

    const nonRevJobsSorted = [...nonRevJobs]
      .filter(
        (j) =>
          Number.isFinite(j.requiredFTE) &&
          Number.isFinite(j.actual) &&
          !(j.requiredFTE === 0 && j.actual === 0)
      )
      .map((j) => ({
        ...j,
        difference: j.requiredFTE - j.actual,
      }))
      .sort((a, b) => (b.difference ?? -Infinity) - (a.difference ?? -Infinity));

    // Revenue chart data
    const revenueData = {
      labels: revJobsSorted.map((j) => j.name),
      datasets: [
        {
          label: t("user.manpowerPlanningAnalysis.chart.requiredFTE"),
          data: revJobsSorted.map((j) => j.requiredFTE),
          backgroundColor: "rgba(54, 162, 235, 0.6)",
        },
        {
          label: t("user.manpowerPlanningAnalysis.chart.actualFTE"),
          data: revJobsSorted.map((j) => j.actual),
          backgroundColor: "rgba(255, 99, 132, 0.6)",
        },
        {
          label: t("user.manpowerPlanningAnalysis.chart.difference"),
          data: revJobsSorted.map((j) => j.difference),
          backgroundColor: "rgba(255, 206, 86, 0.6)", // yellow for visibility
          borderColor: "rgba(255, 206, 86, 1)",
          borderWidth: 1,
          barPercentage: 0.5,
        },
      ],
    };

    // Non-revenue chart data
    const nonRevenueData = {
      labels: nonRevJobsSorted.map((j) => j.name),
      datasets: [
        {
          label: t("user.manpowerPlanningAnalysis.chart.requiredFTE"),
          data: nonRevJobsSorted.map((j) => j.requiredFTE),
          backgroundColor: "rgba(54, 162, 235, 0.6)",
        },
        {
          label: t("user.manpowerPlanningAnalysis.chart.actualFTE"),
          data: nonRevJobsSorted.map((j) => j.actual),
          backgroundColor: "rgba(255, 99, 132, 0.6)",
        },
        {
          label: t("user.manpowerPlanningAnalysis.chart.difference"),
          data: nonRevJobsSorted.map((j) => j.difference),
          backgroundColor: "rgba(255, 206, 86, 0.6)",
          borderColor: "rgba(255, 206, 86, 1)",
          borderWidth: 1,
          barPercentage: 0.5,
        },
      ],
    };

    //---------- FTE Gap Analysis---------------------

    // ---------- Workload Analysis ----------

    const sortedWorkloadJobs = [...workloadJobs].sort((a, b) => b.pct - a.pct); //sorting workload

    const sortedWorkloadJobsNumeric = [...workloadJobs] //adjusting workload to be numerical type
      .map((j) => ({
        ...j,
        pct: Number(j.pct), // ✅ only convert here
      }))
      .sort((a, b) => b.pct - a.pct);

    //Array For Workload Chart: Name,Workload,Color
    const workloadRechartData = sortedWorkloadJobsNumeric.map((j) => ({
      name: j.name,
      pct: j.pct, // already numeric ✅
      color: j.pct > 115 ? "#ef5350" : j.pct < 90 ? "#ffa726" : "#108092",
    }));

    // ---------- Workload Analysis ----------

    // --- Cost Per FTE Chart ---

    //sorting cost per FTE Data
    const sortedJobs = Object.values(jobSalary || {}).sort(
      (a, b) => b.monthlySalary - a.monthlySalary // ascending order; use b - a for descending
    );

    const costPerFteData = sortedJobs.map((j) => ({
      jobTitle: j.jobTitle,
      cost: j.monthlySalary,
    }));

    const opex = spendings * 12;
    const revenue = avgProductivityPerYear;

    const opexRevenueData = [
      { name: "Opex", amount: opex, fill: "#ef5350" }, // red
      { name: "Revenue", amount: revenue, fill: "#66bb6a" }, // green
    ];

    // --- Revenue vs Non-Revenue Annual Salary Charts ---

    const getSalaryColor = (salary) => {
      if (salary < 144000) return "#FFD700"; // 💛 yellow
      if (salary <= 240000) return "#1E90FF"; // 💙 blue
      return "#2E8B57"; // 💚 green
    };

    const revenueSalaryData = [...Object.values(jobSalary || {})]
      .filter((j) => j.revGen)
      .sort((a, b) => b.annualSalary - a.annualSalary)
      .map((j) => ({
        name: j.jobTitle,
        salary: Number(j.annualSalary) || 0,
        color: getSalaryColor(j.annualSalary || 0),
      }));

    const nonRevenueSalaryData = [...Object.values(jobSalary || {})]
      .filter((j) => !j.revGen)
      .sort((a, b) => b.annualSalary - a.annualSalary)
      .map((j) => ({
        name: j.jobTitle,
        salary: Number(j.annualSalary) || 0,
        color: getSalaryColor(j.annualSalary || 0),
      }));

    const employeesList = scenario ? scenarioEmployees : orgEmployees;

    return {
      counts,
      revJobs,
      nonRevJobs,
      // workload,
      staffingData,
      revenueData,
      nonRevenueData,
      opexRevenueData,
      costPerFteData,
      workloadRechartData,
      revenueSalaryData,
      nonRevenueSalaryData,
    };
  }, [data, extraData, jobSalary, selectedJob]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Grid container spacing={2} p={2}>
      {/* Summary Cards */}
      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Typography variant="h6">
              {t("user.manpowerPlanningAnalysis.totalEmployees")}
            </Typography>
            <Typography variant="h4">{extraData?.totalEmployees}</Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Typography variant="h6">
              {t("user.manpowerPlanningAnalysis.understaffedJobs")}
            </Typography>
            <Typography variant="h4" color="error">
              {counts.under}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={4}>
        <Card>
          <CardContent>
            <Typography variant="h6">
              {t("user.manpowerPlanningAnalysis.overstaffedJobs")}
            </Typography>
            <Typography variant="h4" color="warning.main">
              {counts.over}
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Manpower Analysis Chart*/}

      <ManpowerAnalysisChart
        workloadRechartData={workloadRechartData}
        staffingData={staffingData}
        revenueData={revenueData}
        nonRevenueData={nonRevenueData}
        scenario={scenario}
        scenarioJobs={scenarioJobs}
        costPerFteData={costPerFteData}
        opexRevenueData={opexRevenueData}
        revenueSalaryData={revenueSalaryData}
        nonRevenueSalaryData={nonRevenueSalaryData}
        data={data}
        emps={scenario ? scenarioEmployees : orgEmployees}
      />
    </Grid>
  );
};

//  const { scenarioJobs, scenario } = location?.state || {};

ManpowerAnalysisPage.propTypes = {
  scenarioJobs: PropTypes.array,
  scenario: PropTypes.object,
};

export default ManpowerAnalysisPage;
